var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasNotifications)?_c('transition',{attrs:{"name":"notification"}},[_c('form-notification',{attrs:{"status":_vm.status},on:{"remove-notification":function($event){return _vm.removeNotification()}}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }